import { useEffect, useState, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { reactRouterProvider } from './reactRouterProvider';

export function useInitializeReactRouterProvider(): boolean {
    const navigate = useNavigate();
    const [, setSearchParams] = useSearchParams();
    const [isInitialized, setIsInitialized] = useState(false);
    const isMountedRef = useRef(true);

    useEffect(() => {
        // Always initialize with the latest values
        reactRouterProvider.initialize({ navigate, setSearchParams });
        setIsInitialized(true);

        return () => {
            // Only null out if we're actually unmounting (not just re-running due to deps)
            // We track this with isMountedRef which only gets set to false on true unmount
            if (!isMountedRef.current) {
                setIsInitialized(false);
                reactRouterProvider.initialize({ navigate: null, setSearchParams: null });
            }
        };
    }, [navigate, setSearchParams]);

    useEffect(
        () => () => {
            // This cleanup only runs on component unmount (empty deps array)
            isMountedRef.current = false;
        },
        [],
    );

    return isInitialized;
}
